import md5 from 'js-md5'
import http from '../api/http'
import moment from 'moment'

export default {
    install(Vue) {
        Vue.prototype.$md5 = md5 
        Vue.prototype.$http = http
        Vue.prototype.formattm = function(timestamp){
            if (timestamp) {
                return moment(new Date(timestamp)).format("YYYY-MM-DD");
              }
              return null;
        }
        Vue.prototype.formatTime = function(timestamp){
            if (timestamp) {
                return moment(new Date(timestamp)).format("YYYY-MM-DD HH:mm:ss");
              }
              return null;
        }
        Vue.prototype.format13ToDate = function(timestamp){
            if (timestamp) {
                return moment(new Date(timestamp)).format("YYYY-MM-DD");
              }
              return null;
        }
    }
}